import React from "react";
import { TextField, InputAdornment, Button, IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import ArrowRightAltRoundedIcon from "@mui/icons-material/ArrowRightAltRounded";

function SearchInput({ onSearch, placeHolder, searchTerm, setSearchTerm, sx }) {
    placeHolder = placeHolder ? placeHolder : "data";
    const isSearchActive = searchTerm !== "";

    const handleSearch = () => {
        onSearch(searchTerm);
    };

    const handleClearSearch = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setSearchTerm("");
        onSearch("");
        // Reset the data to its original state
    };

    const handleKeyPress = (event) => {
        if (event.key === "Enter") {
            handleSearch();
        }
    };

    return (
        <TextField
            sx={{
                display: "flex",
                justifySelf: "flex-end",
                width: "400px",
                alignSelf: "flex-end",
                backgroundColor: "white",
                ...sx,
            }}
            variant="outlined"
            placeholder={`Search ${placeHolder}`}
            value={searchTerm}
            onKeyPress={handleKeyPress}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                        <Button
                            variant="contained"
                            onClick={handleSearch}
                            sx={{
                                minWidth: "1rem",
                                paddingX: "0.5rem",
                            }}
                        >
                            <ArrowRightAltRoundedIcon />
                        </Button>
                        {isSearchActive && (
                            <IconButton
                                onClick={handleClearSearch}
                                type="reset"
                                size="small"
                            >
                                <CloseIcon />
                            </IconButton>
                        )}
                    </InputAdornment>
                ),
            }}
        />
    );
}

export default SearchInput;
